window.Page = {

    masonry : null,

    projects     : document.querySelectorAll('.project'),
    filters      : document.querySelectorAll('.projects-filter'),
    labels       : document.querySelectorAll('.project-category'),
    activeFilter : null,

    // Let's launch this thing
    liftoff : () => {
        Page.initMasonry()
        Page.filterProjects()
        Page.activateFilterOnLabelClick()
    },

    // My new function block
    initMasonry : () => {
        Page.masonry = Macy({
            container     : '#projects',
            trueOrder     : false,
            waitForImages : true,
            margin        : {
                x : "0.25rlh",
                y : 0,
            },
            columns       : 2,
            breakAt       : {
                750 : 1
            }
        });
    },

    // Filter Projects on click
    filterProjects : () => {
        Page.filters.forEach(filter => {

            filter.addEventListener('click' , () => {

                // If we have clicked on an lready active filter we need to reset a few things
                if (filter == Page.activeFilter) {

                    Page.activeFilter = null;
                    filter.classList.remove('selected')


                    Page.projects.forEach(project => {
                        project.classList.remove('hidden')
                    })

                    // Recalculate the masonry
                    Page.masonry.recalculate(true);

                    return;

                }

                // Disable the old active button
                if (Page.activeFilter)
                    Page.activeFilter.classList.remove('selected')

                // Store the active filter
                Page.activeFilter = filter;

                // Set the active class on it
                Page.activeFilter.classList.add('selected')

                // Hide all the projects
                Page.projects.forEach(project => { project.classList.add('hidden') })

                // The show only the relevant ones
                Page.projects.forEach(project => {
                    if (project.classList.contains(filter.value)) {
                        project.classList.remove('hidden')
                    }
                })

                // recalculate the masonry
                Page.masonry.recalculate(true);


            })

        })
    },

    // Filter based on click n the label
    activateFilterOnLabelClick : () => {
        Page.labels.forEach(label => {
            label.addEventListener('click' , () => {
                let button = document.querySelector(`.projects-filter[value="${label.dataset.value}"]`);
                if (button) button.click()
            })
        })
    }

};

Page.liftoff()